import { take } from "rxjs/operators";
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from "@ngx-translate/core";
import type { MultiSelectChangeEvent } from "primeng/multiselect";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-slide-edit-shared-image-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './shared-image-form.component.html',
    styleUrls: ['./shared-image-form.component.scss'],
    standalone: false
})
export class SharedImageFormComponent {
  #annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType | null;
  #imageIds: string[];
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public translate: TranslateService) {
    // Update Annotation
    this.slideAuthorFacade.currentSelectedSlideAnnotation$.pipe(takeUntilDestroyed()).subscribe((annotation) => {
      this.#annotation = annotation;
      this.#updateImageIds();
    });
  }
  
  #updateImageIds() {
    if (this.#annotation) {
      this.slideAuthorFacade.imageIdsByAnnotation$(this.#annotation.id).pipe(take(1)).subscribe((imageIds) => {
        this.#imageIds = imageIds;
      });
    } else {
      this.#imageIds = [];
    }
  }
  
  onChange(event: MultiSelectChangeEvent) {
    if (!this.#annotation) return;
    const imagesToAdd = event.value.filter((v: string) => !this.#imageIds.includes(v));
    const imagesToRemove = this.#imageIds.filter(v => !event.value.includes(v));
    
    if (imagesToAdd.length > 0) {
      this.slideAuthorFacade.requestAddAnnotationIdToImages(imagesToAdd, this.#annotation.id, 'history.annotation_add_to_images').subscribe({
        error: (result) => this.alertControlFacade.requestAddError(result),
        next: () => this.#updateImageIds()
      });
    } else if (imagesToRemove.length > 0) {
      if (this.#imageIds.length === imagesToRemove.length) {
        imagesToRemove.shift();
      }
      this.slideAuthorFacade.requestRemoveAnnotationFromImages(imagesToRemove, this.#annotation.id, 'history.annotation_remove_from_images').subscribe({
        error: (result) => this.alertControlFacade.requestAddError(result),
        next: () => this.#updateImageIds()
      });
    }
  }
}
